import { cssAnimationAttr, loadedClass } from './_constants'

const cssAnimationObserver = new IntersectionObserver(entries => {
  entries.forEach(entry => {
    if (entry.isIntersecting) {
      entry.target.classList.add(loadedClass)
      cssAnimationObserver.unobserve(entry.target)
    }
  })
})

export const initCssAnimations = page => {
  page
    .querySelectorAll(cssAnimationAttr)
    .forEach(el => cssAnimationObserver.observe(el))
}

export default cssAnimationObserver
